<template>
  <div id="app" :class="{ dark: isDark }">
    <router-view :isDark="isDark" />
  </div>
</template>

<script>
const tp = require("tp-js-sdk");
tp.fullScreen({
  fullScreen: 0,
});

export default {
  data() {
    return {
      isDark: false,
    };
  },
  created() {
    const bodyEl = document.getElementsByTagName("body")[0];
    const isDark = localStorage.getItem("mode");
    if (isDark === "dark") {
      this.isDark = true;
      bodyEl.style.background = "#18191c";
    } else {
      this.isDark = false;
      bodyEl.style.background = "white";
    }
    if (tp.isDarkMode) {
      tp.isDarkMode().then((res) => {
        this.isDark = res.data;
        if (this.isDark) {
          bodyEl.style.background = "#18191c";
        } else {
          bodyEl.style.background = "white";
        }
        localStorage.setItem("mode", this.isDark ? "dark" : "normal");
      });
    }
  },
};
</script>

<style lang="less">
#app {
  padding-bottom: 15px;
}
.dark {
  background: #18191c;
}
</style>
